import { Grid } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const FilterButtonsGrid: FC<PropsWithChildren> = ({ children }) => (
  <Grid templateColumns="repeat(4, 68px)" rowGap="4" columnGap="18px">
    {children}
  </Grid>
);
